import { useEffect } from "react";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open, title, message, confirmLabel = "Conferma", busy, error, onConfirm, onCancel,
}: ConfirmDialogProps) {
  // Esc chiude come «Annulla» (non mentre il comando è in corso)
  useEffect(() => {
    if (!open || busy) return;
    const suTasto = (e: KeyboardEvent) => { if (e.key === "Escape") onCancel(); };
    document.addEventListener("keydown", suTasto);
    return () => document.removeEventListener("keydown", suTasto);
  }, [open, busy, onCancel]);
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={busy ? undefined : onCancel}
    >
      <div
        className="bg-card rounded-lg border border-border max-w-sm w-full p-5 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="font-semibold text-text">{title}</h3>
        <p className="text-sm text-muted-foreground">{message}</p>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            disabled={busy}
            className="min-h-11 px-3 py-2 text-sm border border-border rounded-lg disabled:opacity-50"
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            aria-busy={busy ? true : undefined}
            className="min-h-11 px-3 py-2 text-sm bg-red-600 text-white rounded-lg disabled:opacity-50"
          >
            {busy ? "..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
